import styled from 'styled-components';

export const CertLabelContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
